import { GROUPED_REQUEST_STATUS, REQUEST_STATUS } from '../constants/request'
import type { TrackingRequestStatus } from '../domains/service-tracking/serviceTracking.types'
import type { GroupedRequestStatus } from '../types/requests'

export const groupRequestStatus = (
  requestStatus: TrackingRequestStatus['slug'],
): GroupedRequestStatus => {
  switch (requestStatus) {
    case REQUEST_STATUS.NEW:
    case REQUEST_STATUS.ASSIGNED:
    case REQUEST_STATUS.PAYMENT_PENDING:
      return GROUPED_REQUEST_STATUS.NEW

    case REQUEST_STATUS.DENIED:
    case REQUEST_STATUS.PAYMENT_FAILED:
      return GROUPED_REQUEST_STATUS.VOIDED

    case REQUEST_STATUS.DELAYED:
    case REQUEST_STATUS.ACCEPTED:
    case REQUEST_STATUS.SCHEDULED:
    case REQUEST_STATUS.REASSIGNED:
    case REQUEST_STATUS.CHANGE_REQUEST:
    case REQUEST_STATUS.AWAITING_REVISION:
    case REQUEST_STATUS.ARCHIVED:
      return GROUPED_REQUEST_STATUS.IN_PROGRESS

    case REQUEST_STATUS.COMPLETED:
      return GROUPED_REQUEST_STATUS.COMPLETED

    default:
      return GROUPED_REQUEST_STATUS.UNKNOWN
  }
}
